module.exports = __webpack_public_path__ + "img/pump-hand.24fc11f5.svg";